import python from "../images/development/python.png";
import angular from "../images/development/angular.png";
import bootcamp from "../images/development/bootcamp.png";
import cprogram from "../images/development/cprogram.png";
import java from "../images/development/java.png";
import javascript from "../images/development/javascript.png";
import machine from "../images/development/machine.png";

export const DevelopmentData = [
  {
    id: 1,
    title: "2021 Complete Python Bootcamp From Zero to Hero in Python",
    desc:
      "Learn Python like a Professional Start from the basics and go all the way to creating your own applications and games",
    hours: "22 hours",
    image: python,
    author: "Jose Portilla",
    link: "#",
    rate: "3",
    price: "500",
    type: "Newseller",
  },
  {
    id: 2,
    title: "The Web Developer Bootcamp 2021",
    desc:
      "Become a full-stack web developer with just one course. HTML, CSS, Javascript, Node, React, MongoDB and more!",
    hours: "64 hours",
    image: bootcamp,
    author: "Colt Steele",
    link: "#",
    rate: "4",
    price: "400",
    type: "Bestseller",
  },
  {
    id: 3,
    title: "Machine Learning A-Z™: Hands-On Python & R In Data Science",
    desc:
      "Learn to create Machine Learning Algorithms in Python and R from two Data Science experts. Code templates included.",
    hours: "86 hours",
    image: machine,
    author: "Kirill Eremenko",
    link: "#",
    rate: "4.5",
    price: "550",
    type: "Bestseller",
  },
  {
    id: 4,
    title: "Java Programming Masterclass for Software Developers",
    desc:
      "Learn Java In This Course And Become a Computer Programmer. Obtain valuable Core Java Skills And Java Certification",
    hours: "80 hours",
    image: java,
    author: "Tim Buchalka",
    link: "#",
    rate: "4.3",
    price: "800",
    type: "Newseller",
  },
  {
    id: 5,
    title: "Angular - The Complete Guide (2021 Edition)",
    desc:
      "Master Angular 10 (formerly Angular 2) and build awesome, reactive web apps with the successor of Angular.js",
    hours: "120 hours",
    image: angular,
    author: "Maximilian Schwarzmuller",
    link: "#",
    rate: "4.6",
    price: "700",
    type: "Bestseller",
  },
  {
    id: 6,
    title: "The Complete JavaScript Course 2021: From Zero to Expert!",
    desc:
      "The modern JavaScript course for everyone! Master JavaScript with projects, challenges and theory. Many courses in one!",
    hours: "220 hours",
    image: javascript,
    author: "Jonas Williams",
    link: "#",
    rate: "4.7",
    price: "599",
    type: "Bestseller",
  },
  {
    id: 7,
    title: "Learn C# Programming (In Ten Easy Steps)",
    desc:
      "Learn Unity in C# & Code Your First Seven 2D Video Games for Web, Mac & PC. The Tutorials Cover Tilemap (35 hours)",
    hours: "22 hours",
    image: cprogram,
    author: "Rajesh varma",
    link: "#",
    rate: "4.2",
    price: "399",
    type: "Newseller",
  },
];
